export default __webpack_public_path__ + "static/media/active_campaign.4d04fac0.svg";